(function () {
  var selector = "[data-home-typing-phrases]";
  var typeDelay = 72;
  var deleteDelay = 36;
  var typedPause = 1450;
  var deletedPause = 220;

  function getPhrases(element) {
    try {
      return JSON.parse(element.getAttribute("data-home-typing-phrases") || "[]")
        .filter(function (phrase) {
          return typeof phrase === "string" && phrase.length > 0;
        });
    } catch (error) {
      return [];
    }
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function startTyping(element) {
    if (element.getAttribute("data-home-typing-active") === "true") return;

    var phrases = getPhrases(element);
    if (phrases.length < 2) return;

    element.setAttribute("data-home-typing-active", "true");
    element.textContent = phrases[0];

    if (prefersReducedMotion()) return;

    var phraseIndex = 0;
    var letterIndex = phrases[0].length;
    var isDeleting = true;

    function tick() {
      if (!document.body.contains(element)) return;

      var phrase = phrases[phraseIndex];
      var delay = isDeleting ? deleteDelay : typeDelay;

      letterIndex += isDeleting ? -1 : 1;
      element.textContent = phrase.slice(0, letterIndex);

      if (isDeleting && letterIndex === 0) {
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        delay = deletedPause;
      } else if (!isDeleting && letterIndex === phrases[phraseIndex].length) {
        isDeleting = true;
        delay = typedPause;
      }

      window.setTimeout(tick, delay);
    }

    window.setTimeout(tick, typedPause);
  }

  function initTypingHeadlines() {
    document.querySelectorAll(selector).forEach(startTyping);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTypingHeadlines);
  } else {
    initTypingHeadlines();
  }
})();
